import { BookClubCarousel } from './bookclubcarousel';

export interface UserBookClubsCollection {
  canCreateExperiences: boolean;
  carousels: BookClubCarousel[];
}

export enum BookClubSection {
  HOME = '',
  CREATE_BOOKCLUB = 'createExperience',
  MY_GRADES = 'grades',
  MY_CERTIFICATES = 'certificates',
}
